import { useGetProjectQuery } from 'src/hooks/useGetProjectQuery';

/** Whether this project's org can use Andi: the project's `andiChat` entitlement, which the Ampersand API sets per
 *  environment from its org allowlist. `undefined` until the project has loaded. */
export const useAndiChatEnabled = (): boolean | undefined => {
  const { data: project, isSuccess } = useGetProjectQuery();
  return isSuccess ? project?.entitlements?.andiChat?.value === true : undefined;
};
